import React, { useEffect, useState, createContext } from 'react'

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { useLocation } from 'react-router-dom';
import CreateAccountingEntry from './CreateAccountingEntry/index';
// import AccountingEntriesTable from "./AccountingEntriesTable"
 
const index = () => {
  const { state } = useLocation();
  // let req = SearchStringOrIntReq5
 
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <CreateAccountingEntry />
         
    </DashboardLayout>
  )
}

export default index